import React, { useState } from "react";
import axios from "axios";
import { useLang } from "@/i18n/LanguageContext";
import { PageShell } from "@/components/PageShell";
import { Loader2, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Devis() {
  const { t, locale } = useLang();
  const [form, setForm] = useState({
    name: "", email: "", phone: "", country: "", city: "",
    pillar: "geobiologie", surface_m2: "", property_type: "", description: "",
  });
  const [status, setStatus] = useState({ loading: false, ok: false, err: "" });

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, ok: false, err: "" });
    try {
      const payload = { ...form, locale, surface_m2: form.surface_m2 ? parseInt(form.surface_m2) : null };
      await axios.post(`${API}/quote`, payload);
      setStatus({ loading: false, ok: true, err: "" });
      setForm({ name: "", email: "", phone: "", country: "", city: "", pillar: "geobiologie", surface_m2: "", property_type: "", description: "" });
    } catch (err) {
      setStatus({ loading: false, ok: false, err: err.response?.data?.detail || t("forms.error") });
    }
  };

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <PageShell testId="page-devis" title={t("devis.title")}>
      <form onSubmit={submit} className="grid md:grid-cols-2 gap-5 max-w-4xl glass rounded-2xl p-8 glow-border" data-testid="devis-form">
        <div>
          <label className="label-overline block mb-2">{t("forms.name")}</label>
          <input className="input-tech" required value={form.name} onChange={update("name")} data-testid="devis-name" />
        </div>
        <div>
          <label className="label-overline block mb-2">{t("forms.email")}</label>
          <input className="input-tech" type="email" required value={form.email} onChange={update("email")} data-testid="devis-email" />
        </div>
        <div>
          <label className="label-overline block mb-2">{t("forms.phone")}</label>
          <input className="input-tech" value={form.phone} onChange={update("phone")} data-testid="devis-phone" />
        </div>
        <div>
          <label className="label-overline block mb-2">{t("forms.country")}</label>
          <input className="input-tech" required value={form.country} onChange={update("country")} data-testid="devis-country" />
        </div>
        <div>
          <label className="label-overline block mb-2">{t("forms.city")}</label>
          <input className="input-tech" value={form.city} onChange={update("city")} data-testid="devis-city" />
        </div>
        <div>
          <label className="label-overline block mb-2">{t("forms.pillar")}</label>
          <select className="input-tech" value={form.pillar} onChange={update("pillar")} data-testid="devis-pillar">
            <option value="geobiologie">Géobiologie</option>
            <option value="magnetisme">Magnétisme</option>
            <option value="cuisine">Cuisine Vivante</option>
          </select>
        </div>
        <div>
          <label className="label-overline block mb-2">{t("forms.surface")}</label>
          <input className="input-tech" type="number" value={form.surface_m2} onChange={update("surface_m2")} data-testid="devis-surface" />
        </div>
        <div>
          <label className="label-overline block mb-2">{t("forms.property")}</label>
          <input className="input-tech" placeholder="Maison, appartement, local..." value={form.property_type} onChange={update("property_type")} data-testid="devis-property" />
        </div>
        <div className="md:col-span-2">
          <label className="label-overline block mb-2">{t("forms.message")}</label>
          <textarea className="input-tech min-h-[140px]" required value={form.description} onChange={update("description")} data-testid="devis-description" />
        </div>
        <div className="md:col-span-2 flex items-center gap-4">
          <button type="submit" className="btn-gold" disabled={status.loading} data-testid="devis-submit">
            {status.loading ? <Loader2 size={14} className="animate-spin" /> : null}
            {status.loading ? t("forms.submitting") : t("forms.submit")}
          </button>
          {status.ok && (
            <span className="inline-flex items-center gap-2 text-sm text-[#00F0FF]" data-testid="devis-success">
              <CheckCircle2 size={16} /> {t("forms.success")}
            </span>
          )}
          {status.err && <span className="text-sm text-red-400" data-testid="devis-error">{status.err}</span>}
        </div>
      </form>
    </PageShell>
  );
}
